var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-hold"},[_c('label',{staticClass:"radio",attrs:{"for":_vm.radioId}},[_vm._t("default"),_c('input',{attrs:{"id":_vm.radioId,"type":"radio","required":_vm.required,"disabled":_vm.disabled},domProps:{"checked":_vm.isChecked,"value":_vm.radioValue},on:{"change":_vm.change}}),_c('span')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }